function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247.859,
    height: 51.161,
    viewBox: "0 0 65.579 13.536",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fontWeight: 400,
    fontFamily: "sans-serif",
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 79.474,
    y: 122.552,
    transform: "matrix(1.04992 0 0 .95246 -76.914 -106.999)",
    fontSize: 10.08,
    fill: "#649926",
    strokeWidth: 0.252
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 79.474,
    y: 122.552,
    style: {
      InkscapeFontSpecification: "'Verdana, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start"
    },
    fontSize: 13.44,
    fontFamily: "Verdana"
  }, "\\")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 76.184,
    y: 122.555,
    transform: "matrix(1.04992 0 0 .95246 -76.914 -106.999)",
    fontSize: 10.08,
    fill: "#649926",
    strokeWidth: 0.252
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 76.184,
    y: 122.555,
    style: {
      InkscapeFontSpecification: "'Verdana, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start"
    },
    fontSize: 13.44,
    fontFamily: "Verdana"
  }, "\\")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 72.798,
    y: 122.555,
    transform: "matrix(1.04992 0 0 .95246 -76.914 -106.999)",
    fontSize: 10.08,
    fill: "#649926",
    strokeWidth: 0.252
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 72.798,
    y: 122.555,
    style: {
      InkscapeFontSpecification: "'Verdana, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start"
    },
    fontSize: 13.44,
    fontFamily: "Verdana"
  }, "\\")), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 91.546,
    y: 118.406,
    fontSize: 10.583,
    strokeWidth: 0.265,
    transform: "translate(-76.914 -106.999)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 91.546,
    y: 118.406,
    style: {
      InkscapeFontSpecification: "'Verdana, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start"
    },
    fontFamily: "Verdana"
  }, "SlideSpiel"))));
}
export default __webpack_public_path__ + "115d2579014c7b571edd51ab81611f77.svg";
export { SvgLogo as ReactComponent };